import { LoadingButton } from "../button/loading-button";

interface ConfirmationModalProps {
  title?: string;
  description?: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  confirmLabel?: string;
}

export function ConfirmationModal({
  title = "Confirmar exclusão",
  description,
  isOpen,
  onCancel,
  onConfirm,
  isLoading = false,
  confirmLabel = "Confirmar",
}: ConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => {
        if (!isLoading) {
          onCancel();
        }
      }}
    >
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h2 className="mb-4 text-lg font-semibold text-slate-900">{title}</h2>

        {description && (
          <p className="mb-6 text-sm text-slate-600">{description}</p>
        )}

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary cursor-pointer"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <LoadingButton
            type="button"
            onClick={onConfirm}
            className="btn btn-danger cursor-pointer"
            isLoading={isLoading}
            loadingLabel={confirmLabel}
          >
            {confirmLabel}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}
